import DlpRules from '@Policy/DataLossPrevention/PolicyTemplate/Filters/Dlp';

const DlpRulesExchangeInline = () => {
  return (
    <DlpRules
      applyBoundShow={false}
      scanTargetShow={true}
      complianceRuleNoteShow={false}
      advancedOptionsShow={true}
      fileAdvancedOptionsShow={false}
      mipShow={false}
      showHeaderScan={true}
      showApprovedSenders={true}
    />
  );
};
export default DlpRulesExchangeInline;
